export default {
      id: "icon-deposit-usage",
      viewBox: "0 -4 24 24",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-deposit",
      toString: function () {
        return this.url;
      }
    }